import React from "react";
import { Box, Divider, Typography, Button } from "@mui/material";
import { theme } from "../services/Theme";
import { Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

function Footer({ openPrivacySettings }) {
  const openInstagramPage = () => {
    window.open("https://www.instagram.com/haasfab_llc/", "_blank");
  };
  const openFacebookPage = () => {
    window.open("https://www.facebook.com/HaasFab-100925839159371", "_blank");
  };
  const openEmailTo = () => {
    window.open("mailto:business@haasfab.com", "_self");
  };
  const callPhone = () => {
    window.open("tel:+14198069442", "_self");
  };

  const getYear = () => {
    let date = new Date();
    date = date.getFullYear();
    return date;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",

        backgroundColor: theme.palette.background.main,
        alignItems: "center",
        justifyContent: "center",
        marginTop: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          flexWrap: "wrap",
          gap: { xs: 1, sm: 0 },
          width: "100%",
          minHeight: { xs: "auto", sm: "50px" },
          backgroundColor: theme.palette.background.main,
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 1.25, sm: 0 },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Button
            onClick={openFacebookPage}
            className="noselect"
            sx={{
              textDecoration: "none",
              color: theme.palette.text.light,
              minWidth: "auto",
              px: 1.5,
            }}
          >
            <FacebookIcon />
          </Button>

          <Button
            onClick={openInstagramPage}
            className="noselect"
            sx={{
              textDecoration: "none",
              color: theme.palette.text.light,
              minWidth: "auto",
              px: 1.5,
            }}
          >
            <InstagramIcon />
          </Button>
        </Box>

        <Button
          onClick={openEmailTo}
          className="noselect"
          variant="outlined"
          sx={{
            textDecoration: "none",
            color: theme.palette.text.light,
            borderColor: theme.palette.divider,
            ml: { xs: 0, sm: 2.5 },
            fontSize: { xs: "0.78rem", sm: "0.9rem" },
            px: { xs: 1.4, sm: 2 },
            py: 0.4,
            maxWidth: { xs: "90vw", sm: "none" },
            "&:hover": {
              borderColor: theme.palette.text.light,
            },
          }}
        >
          Business@HaasFab.com
        </Button>

        <Button
          onClick={callPhone}
          className="noselect"
          variant="outlined"
          sx={{
            textDecoration: "none",
            color: theme.palette.text.light,
            borderColor: theme.palette.divider,
            ml: { xs: 0, sm: 1.25 },
            fontSize: { xs: "0.78rem", sm: "0.9rem" },
            px: { xs: 1.4, sm: 2 },
            py: 0.4,
            maxWidth: { xs: "90vw", sm: "none" },
            "&:hover": {
              borderColor: theme.palette.text.light,
            },
          }}
        >
          (419) 806-9442
        </Button>
      </Box>
      <Divider width="95%" sx={{ maxWidth: "1000px" }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          flexWrap: "wrap",
          gap: { xs: 0.5, sm: 0 },
          width: "100%",
          minHeight: { xs: "auto", sm: "50px" },
          backgroundColor: theme.palette.background.main,
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 1.2, sm: 0 },
        }}
      >
        <Typography color={theme.palette.text.light} sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}>
          © Copyright - HaasFab, LLC {getYear()}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 1.2, sm: 1 },
            ml: { xs: 0, sm: 1.25 },
          }}
        >
          <Link
            to="/privacy-policy"
            className="noselect"
            style={{
              textDecoration: "none",
              color: theme.palette.text.light,
            }}
          >
            <Typography sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}>Privacy Policy</Typography>
          </Link>
          <Button
            className="noselect"
            onClick={openPrivacySettings}
            sx={{
              textTransform: "none",
              color: theme.palette.text.light,
              minWidth: "auto",
              p: 0,
            }}
          >
            <Typography sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}>Privacy Settings</Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
